import logoVideo from '../../assets/video/logoVideo.webm';
import styles from './LogoVideo.module.css';

export const LogoVideo = () => {
  return (
    <video autoPlay="autoplay" muted="muted" className={styles.logoVideo}>
      <source src={logoVideo} type="video/webm" />
    </video>
  );
};
